import { Footer, Header } from "components";
import React from "react";
import BookingFlowScreeningIndicator from "./booking-flow-screening-indicator";
import BookingFlowStepNav from "./booking-flow-step-nav";
import { BookingFlowStepId } from "./types";
import styles from "./booking-flow-layout.module.css";

type BookingFlowLayoutProps = {
    children: React.ReactNode;
    currentStep: BookingFlowStepId;
    showScreeningIndicator?: boolean;
    skipConsultationStep?: boolean;
    /** e.g. `modal-open` for availability location modal */
    pageClassName?: string;
    /** Legacy step content (e.g. clinic availability) with its own inset */
    legacyBodyContent?: boolean;
};

const BookingFlowLayout: React.FunctionComponent<BookingFlowLayoutProps> = ({
    children,
    currentStep,
    showScreeningIndicator = true,
    skipConsultationStep,
    pageClassName,
    legacyBodyContent = false,
}) => {
    return (
        <div
            className={["page", styles.page, pageClassName]
                .filter(Boolean)
                .join(" ")}
        >
            <Header />
            <div className={styles.cardShell}>
                {showScreeningIndicator && <BookingFlowScreeningIndicator />}
                <BookingFlowStepNav
                    currentStep={currentStep}
                    skipConsultationStep={skipConsultationStep}
                />
                <div
                    className={[
                        styles.body,
                        legacyBodyContent ? styles.bodyLegacyContent : "",
                    ]
                        .filter(Boolean)
                        .join(" ")}
                >
                    {children}
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default BookingFlowLayout;
